import { useEffect } from 'react'
import Select from 'react-select'
import { AssetTypeDDLAPI, FinancialYearDDLAPI, MonthDDLAPI, WardNameDDLAPI, Flag, ZoneDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const ZoneDataDDLS = (props) => {
    const { ZoneName, setZoneName, PopUpField, M_AssetTypeID, rowData, Flag, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    // console.log(M_AssetTypeID)

    useEffect(() => {
        const data = { UserID, token }
        dispatch(ZoneDDLAPI({ data }))
    }, [IsPost])

    const { ZoneData } = useSelector(state => state.ZoneDDLData)

    useEffect(() => {
        handleZoneDDL()
    }, [ZoneData])

    const handleZoneDDL = () => {
        // console.log(DeptDDLDataa)
        if (ZoneData && ZoneData.table && ZoneData.table.length > 0) {
            let list = ZoneData.table.map((item, index) => ({
                value: item.m_ZoneID,
                label: item.zoneName,
            }))
            setZoneName({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_ZoneID : 0,
                Label: Flag === 'Update' ? rowData.zoneName : "Select...",
            })
        }

        else {
            setZoneName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label for=""><b>Zone Name {Flag && <AstricSign />} </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                isDisabled = {Flag === 'Update' ? 'disabled' : 0}
                maxMenuHeight={150}
                value={{ value: ZoneName.ID, label: ZoneName.Label }}
                onChange={(e) => {
                    e ?
                        setZoneName({ ...ZoneName, ID: e.value, Label: e.label })
                        :
                        setZoneName({ ...ZoneName, ID: 0, Label: "Select..." })

                }}
                options={ZoneName.DDL}
            />
        </div>
    )
}